import * as Yup from "yup";

export const BasicInfoSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  headline: Yup.string().required("Headline is required"),
  summary: Yup.string().min(50, "Minimum 50 characters required"),
});

export const ContactSchema = Yup.object({
  email: Yup.string().email("Invalid email").required("Email is required"),
  phone: Yup.string().required("Phone is required"),
  city: Yup.string().required("City is required"),
  country: Yup.string().required("Country is required"),
});

export const LanguageSchema = Yup.object({
  languages: Yup.array().of(
    Yup.object({
      language: Yup.string().required("Language is required"),
      level: Yup.string().required("Proficiency is required"),
    })
  ),
});

export const SkillsSchema = Yup.object({
  skills: Yup.array()
    .of(Yup.string().required("Skill cannot be empty"))
    .min(1, "Add at least one skill"),
});

export const WorkExperienceSchema = Yup.object({
  experiences: Yup.array().of(
    Yup.object({
      company: Yup.string().required("Company is required"),
      designation: Yup.string().required("Designation is required"),
      employmentType: Yup.string().required("Employment type is required"),
      startDate: Yup.mixed().required("Start date is required"),
      currentlyWorking: Yup.boolean(),
      endDate: Yup.mixed().when("currentlyWorking", {
        is: false,
        then: (schema) => schema.required("End date is required"),
        otherwise: (schema) => schema.nullable(),
      }),
      description: Yup.string(),
    })
  ),
});

export const EducationSchema = Yup.object({
  education: Yup.array().of(
    Yup.object({
      course: Yup.string().required("Course is required"),
      institute: Yup.string().required("Institute is required"),
      percentage: Yup.string(),
      startDate: Yup.mixed().required("Start date is required"),
      endDate: Yup.mixed().nullable(),
      description: Yup.string(),
    })
  ),
});

export const TrainingCertSchema = Yup.object({
  certificates: Yup.array().of(
    Yup.object({
      title: Yup.string().required("Title is required"),
      issuer: Yup.string().required("Issuer is required"),
      year: Yup.string().required("Year is required"),
    })
  ),
})

export const AchievementsSchema = Yup.object({
  achievements: Yup.array().of(
    Yup.object({
      title: Yup.string().required("Title is required"),
      description: Yup.string().required("Description is required"),
    })
  ),
});

export const HobbiesSchema = Yup.object({
  hobbies: Yup.array()
    .of(Yup.string().required("Hobby cannot be empty"))
    .min(1, "Add at least one hobby"),
});
